<template>
<v-container>
  <v-form v-model="currentValid">
    <v-row>
      <v-col cols="12" sm="12">
        <v-text-field
          v-model="currentPassword"
          :rules="[rules.required]"
          :label="$t('Settings.currentpass')"
          @change="sendCurrentPassword"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
          required
        >
          <v-tooltip top v-if="currentPasswordIcon!=null" slot="prepend">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon :color="currentPasswordIconColor">{{currentPasswordIcon}}</v-icon>
              </v-btn>
            </template>
            <span>{{currentPasswordIconMsg}}</span>
          </v-tooltip>
        </v-text-field>
      </v-col>
    </v-row>
  </v-form>  
  <v-form v-model="newValid">
    <v-row>
      <v-col cols="12" sm="12">
        <v-text-field
          v-model="newPassword"
          :rules="[rules.required, rules.min, rules.max, rules.uppercase, rules.lowercase,rules.digit, rules.nospace]"
          :hint="$t('Login.RegisterComponent.password-hint')"
          counter
          :label="$t('Settings.newpass')"
          @change="sendNewPassword"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show2 ? 'text' : 'password'"
          @click:append="show2 = !show2"
          required
        >
          <v-tooltip top v-if="newPasswordIcon!=null" slot="prepend">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon :color="newPasswordIconColor">{{newPasswordIcon}}</v-icon>
              </v-btn>
            </template>
            <span>{{newPasswordIconMsg}}</span>
          </v-tooltip>
        </v-text-field>
      </v-col>

      <v-col cols="12" sm="12">
        <v-text-field
          v-model="verifNewPassword"
          :rules="[rules.required, rules.min, rules.max, rules.uppercase, rules.lowercase,rules.digit, rules.nospace]"
          :hint="$t('Login.RegisterComponent.password-hint')"
          counter
          :label="$t('Settings.verifnewpass')"
          @change="sendNewPassword"
          :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show3 ? 'text' : 'password'"
          @click:append="show3 = !show3"
          required
        >
          <v-tooltip top v-if="newPasswordIcon!=null" slot="prepend">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon :color="newPasswordIconColor">{{newPasswordIcon}}</v-icon>
              </v-btn>
            </template>
            <span>{{newPasswordIconMsg}}</span>
          </v-tooltip>
        </v-text-field>
      </v-col>
    </v-row>
  </v-form>
</v-container>
</template>

<script>
import axios from "axios";

export default {
  props: {
    username: String
  },
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      currentPassword: "",
      newPassword: "",
      verifNewPassword: "",
      currentPasswordIcon: null,
      currentPasswordIconColor: null,
      currentPasswordIconMsg: "",
      newPasswordIcon: null,
      newPasswordIconColor: null,
      newPasswordIconMsg: "",
      currentValid: false,
      newValid: false,
      rules: {
        required: value =>
          !!value || this.$t("Login.RegisterComponent.rules.required"),
        min: v => v.length >= 8 || this.$t("Login.RegisterComponent.rules.min"),
        max: v =>
          v.length <= 20 || this.$t("Login.RegisterComponent.rules.max"),
        uppercase: value =>
          /^(?=.*[A-Z])/.test(value) ||
          this.$t("Login.RegisterComponent.rules.uppercase"),
        lowercase: value =>
          /^(?=.*[a-z])/.test(value) ||
          this.$t("Login.RegisterComponent.rules.lowercase"),
        digit: value =>
          /^(?=.*[0-9])/.test(value) ||
          this.$t("Login.RegisterComponent.rules.digit"),
        nospace: value =>
          /^\S+$/.test(value) ||
          this.$t("Login.RegisterComponent.rules.nospace")
      }
    };
  },
  computed: {
    checkForm: function() {
      return (
        this.currentPasswordIconColor == "success" &&
        this.newPasswordIconColor == "success" &&
        this.currentValid &&
        this.newValid
      );
    },
    checkCurrentPassword: function() {
      return this.currentPasswordIconColor == "success";
    }
  },
  methods: {
    sendCurrentPassword: function() {
      if (this.currentPassword != "") {
        this.sendNewPassword();
        axios
          .post(process.env.VUE_APP_API_ADDR + "/api/auth/login", {
            login: this.username,
            password: this.currentPassword
          })
          .then(res => {
            if (res.data.success) {
              this.currentPasswordIcon = "mdi-checkbox-marked-circle";
              this.currentPasswordIconColor = "success";
              this.currentPasswordIconMsg = this.$t(
                "Settings.Icon.correctpass"
              );
              this.$emit("passformcheck", this.checkForm);
              this.$emit("currentPasscheck", this.checkCurrentPassword);
              this.$emit("currentpassword", this.currentPassword);
            }
          })
          .catch(err => {
            console.log(err.response.data.errorMessage);
            this.currentPasswordIcon = "mdi-alert-circle";
            this.currentPasswordIconColor = "error";
            this.currentPasswordIconMsg = this.$t(
              "Settings.Icon.incorrectpass"
            );
            this.$emit("passformcheck", this.checkForm);
            this.$emit("currentPasscheck", this.checkCurrentPassword);
          });
      } else {
        this.currentPasswordIcon = null;
        this.currentPasswordIconColor = null;
        this.currentPasswordIconMsg = null;
        this.$emit("passformcheck", this.checkForm);
        this.$emit("currentPasscheck", this.checkCurrentPassword);
      }
    },
    sendNewPassword: function() {
      if (this.newPassword != undefined && this.verifNewPassword != undefined) {
        if (this.newPassword != "" && this.verifNewPassword != "") {
          if (this.checkNewPassword()) {
            if (!this.newValid) {
              this.newPasswordIcon = "mdi-alert-circle";
              this.newPasswordIconColor = "error";
              this.newPasswordIconMsg = this.$t(
                "Settings.Icon.badformatpass"
              );
              this.$emit("passformcheck", this.checkForm);
              this.$emit("currentPasscheck", this.checkCurrentPassword);
            } else {
              this.newPasswordIcon = "mdi-checkbox-marked-circle";
              this.newPasswordIconColor = "success";
              this.newPasswordIconMsg = this.$t(
              "Settings.Icon.matchpass"
            );
              this.$emit("passformcheck", this.checkForm);
              this.$emit("currentPasscheck", this.checkCurrentPassword);
              this.$emit("newpassword", this.newPassword);
            }
          } else {
            this.newPasswordIcon = "mdi-alert-circle";
            this.newPasswordIconColor = "error";
            this.newPasswordIconMsg = this.$t(
              "Settings.Icon.nomatchpass");
            this.$emit("passformcheck", this.checkForm);
            this.$emit("currentPasscheck", this.checkCurrentPassword);
          }
        } else {
          this.newPasswordIcon = null;
          this.newPasswordIconColor = null;
          this.newPasswordIconMsg = null;
          this.$emit("passformcheck", this.checkForm);
          this.$emit("currentPasscheck", this.checkCurrentPassword);
        }
      } else {
        this.newPasswordIcon = null;
        this.newPasswordIconColor = null;
        this.newPasswordIconMsg = null;
        this.$emit("passformcheck", this.checkForm);
        this.$emit("currentPasscheck", this.checkCurrentPassword);
      }
    },
    checkNewPassword: function() {
      return this.newPassword == this.verifNewPassword;
    }
  }
};
</script>